export const OPEN_BADGE_SPEC_V2 = 'https://w3id.org/openbadges/v2';
export const BADGE_CLASS_SPEC = 'https://w3id.org/openbadges#BadgeClass';
export const ASSERTION_SPEC = 'https://w3id.org/openbadges#Assertion';
export var OpenBadgeClassTypes;
(function (OpenBadgeClassTypes) {
    OpenBadgeClassTypes["ASSERTION"] = "Assertion";
    OpenBadgeClassTypes["BADGE"] = "BadgeClass";
    OpenBadgeClassTypes["ISSUER"] = "Profile";
})(OpenBadgeClassTypes || (OpenBadgeClassTypes = {}));
//# sourceMappingURL=model.v2.js.map